var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('modal', {
    staticClass: "dialer_animation right_side_popup m-w-600 scrollable bigSquareCheckbox IosModal",
    attrs: {
      "width": "50%",
      "scrollable": true,
      "height": "auto",
      "name": _vm.modalName
    },
    on: {
      "before-open": function ($event) {
        return _vm.onBeforeOpen($event);
      },
      "before-close": function ($event) {
        return _vm.onBeforeClose();
      }
    }
  }, [_c('Voicemail', {
    attrs: {
      "accountcode": _vm.data.accountcode
    },
    on: {
      "back": function ($event) {
        return _vm.$modal.hide(_vm.modalName);
      }
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }